import { api } from '@/config/api';
import type { BusinessReport } from './reports.service';

export interface HealthInfo { qualityRating?: string; messagingLimitTier?: string; fetchedAt: string; staleSince?: string; }

export interface DashboardOverview {
  sales?: BusinessReport['sales'];
  contactCount: number; groupCount: number; optedInCount: number;
  recentImports: Array<{ importUid: string; filename: string; totalRows: number; inserted: number; status: string; createdAt: string }>;
  recentActivity: Array<{ _id: string; action: string; actorUid: string; createdAt: string; targetType: string }>;
  health: HealthInfo | null;
  period?: { days: number; since: string };
  newContactsInPeriod?: number;
  newLeadsInPeriod?: number;
  dealsWonInPeriod?: number;
}

export interface PerRepRow {
  userUid: string;
  fullName: string;
  email: string;
  leadsAssigned: number;
  dealsOwned: number;
  dealsWon: number;
  dealsLost: number;
  wonValueByCurrency: Record<string, number>;
  lastActiveAt?: string;
}

export interface IndustryDashboard {
  family: string | null;
  timezone?: string;
  date?: string;
  widgets: Array<{ key: string; label: string; href: string; count: number; hint: string; seriesLabel: string; series: Array<{ date: string; value: number }> }>;
}

export const dashboardService = {
  // 404 = a backend deployed before this endpoint existed; the panel hides instead of toasting.
  industry: async (): Promise<IndustryDashboard> => (await api.get('/slighter_crm/dashboard/industry', { expectedStatuses: [404] })).data,
  overview: async (days?: number): Promise<DashboardOverview> =>
    (await api.get('/slighter_crm/dashboard/overview', { params: days ? { days } : {} })).data,
  perRep: async (days?: number): Promise<PerRepRow[]> =>
    (await api.get('/slighter_crm/dashboard/per-rep', { params: days ? { days } : {} })).data,
};
